import { getOamIntlConfigFileContent } from "./utils";
import createT from "./createT";

const getT = (bindNameSpace?: string) => {
  const config = getOamIntlConfigFileContent();
  const t = createT(undefined, config, bindNameSpace);
  return t;
};
export default getT;
